export default "__VITE_ASSET__DZoE_Osi__"